<template lang="pug">
  .messagepage
    .right_col(role='main')
      .page-title
        .title_left
          h2 メッセージ
      .x_panel
        .x_content
          table.table.table-bordered.datatable
            tbody
              tr.active
                th.isvalid 有効・無効
                th.formname フォーム名
                th.readingmessagebutton メッセージ
                th.notcompatible 未対応
                th.nowcorrespondence 対応中
              tr(v-for='(form, index) in forms')
                td.tdcentersmall
                  p.enable(v-if='form.is_valid == 1') 有効
                  p.disabled(v-else) 無効
                td.updowncenter
                  p {{form.name}}
                td.tdcenter
                  router-link(:to="{ name: 'messages', params: { id: form.id } }").btn.btn-success
                    i#readingmessage.fa.fa-envelope(aria-hidden='true') &nbsp;メッセージを見る
                td.tdcenter
                  //未対応件数
                  p {{form.not_correspondence}}
                td.tdcenter
                  //応対中件数
                  p {{form.during_correspondence}}
</template>

<script>
import Request from '@/service/Request'
import Loader from '@/service/Loader'
// import qs from 'querystring'

export default {
  data () {
    return {
      forms: []
    }
  },
  mounted () {
    this.bind()
  },
  methods: {
    // データバインド
    bind () {
      this.$nextTick(() => { Loader.show() })
      let axios = Request.instance(true)
      let result = axios.get('/form')
      let vue = this
      vue.forms = []
      result.then((res) => {
        vue.forms = res.data
        // vue.$set(vue, 'forms', res.data)
        this.$nextTick(() => { Loader.hide() })
      })
    }
  },
  components: {
  }
}
</script>

<style lang="stylus" scoped>
.datatable
  p
    font-size: 14px
    margin: 0 !important
    padding: 1px
  .updowncenter
    vertical-align: middle
  .tdcenter
    vertical-align: middle
    p
      font-size: 25px
      color: #26B99A
      font-weight: bold
      margin: 0
  .tdcentersmall
    p
      text-align: center
      padding: 8px
      font-weight: bold
      margin: 0
    .enable
      color: #26B99A
    .disabled
      color: #73879C
  .btn-success
    padding: 5px 15px
    margin: 0
  .isvalid
    width: 8%
  .formname
    width: 25%
  .readingmessagebutton
    width: 3%
  .notcompatible
    width: 5%
  .nowcorrespondence
    width: 5%
.readingmessage
  color: #FFF
</style>



// WEBPACK FOOTER //
// Information.vue?ad51e53e